// extracted by mini-css-extract-plugin
export default {"window":"AuthTemplate_window__rzkgf","window_inner":"AuthTemplate_window_inner__4qL+e"};